import { render, staticRenderFns } from "./BookingFormList.vue?vue&type=template&id=5f5c871c&"
import script from "./BookingFormList.vue?vue&type=script&lang=js&"
export * from "./BookingFormList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports